import { produce } from 'immer';

import { RevertCampaignServiceEditor } from '../../actions/campaignServiceEditor/revertCampaignServiceEditor';
import { CampaignServiceEditorState } from '../../typings/campaignServiceEditor';

export function revertCampaignServiceEditor(
    state: CampaignServiceEditorState,
    action: RevertCampaignServiceEditor
): CampaignServiceEditorState {
    return produce(state, draft => {
        const { editorId, service } = action;

        draft[editorId].isOpen = false;
        draft[editorId].serviceId = service.serviceId;
        draft[editorId].isMobile = service.isMobile;
    });
}
